import { DataProxy } from 'apollo-cache';
import { FetchResult } from 'apollo-link';
import { ExecutionResult } from 'graphql';
import produce, { Draft } from 'immer';
import { findIndex } from 'lodash';

import { GetGroupModeratorsDocument, GroupModerator } from 'api';

type ReducerArgs = (
  addedManagers: GroupModerator[],
  result: ExecutionResult['data'],
  targetUserId: string,
) => void;

interface IGetModeratorsByGroup {
  group_id: string;
  targetUserId: string;
}

interface IReducer {
  cache: DataProxy;
  result: FetchResult;
  variables: IGetModeratorsByGroup;
  name: string;
}

interface IReducers {
  addManager: ReducerArgs;
  removeManager: ReducerArgs;
}

const reducers: IReducers = {
  addManager: produce((draft: Draft<GroupModerator[]>, result) => {
    draft.push(result);
    return draft;
  }),
  removeManager: produce((draft: Draft<GroupModerator[]>, result, targetUserId) => {
    const index = findIndex(
      draft,
      (moderator: GroupModerator) => moderator.user_id === targetUserId,
    );
    draft.splice(index, 1);
    return draft;
  }),
};

export default (options: IReducer) => {
  const { name, cache, result, variables } = options;

  const cacheOptions = {
    query: GetGroupModeratorsDocument,
    variables: { group_id: variables.group_id },
  };

  const { getModeratorsByGroup } = cache.readQuery(cacheOptions);

  if (!getModeratorsByGroup.length) {
    return;
  }

  const mutations = Object.keys(result.data);

  mutations.forEach(mutation => {
    const updated = reducers[name](
      getModeratorsByGroup,
      result.data[mutation],
      variables.targetUserId,
    );

    cache.writeQuery({
      ...cacheOptions,
      data: { getModeratorsByGroup: updated },
    });
  });
};
